import {Spin} from "antd";
import {StyledReadyTowItDrawBox} from "./style";
import {UseQueryResult} from "@tanstack/react-query";
import {TConnectedBankApiResponse} from "../../../../../../../react-query-hooks/payout";

export function ReadyToWithdraw({
  accountBalanceData,
  connectedBankData,
  isAccountBalanceOrConnectedBankError,
  isAccountBalanceOrConnectedBankLoading,
  isAccountBalanceOrConnectedBankFetching,
}: {
  accountBalanceData: UseQueryResult<{
    balance: number;
  }>;
  connectedBankData: UseQueryResult<TConnectedBankApiResponse>;
  isAccountBalanceOrConnectedBankError: boolean;
  isAccountBalanceOrConnectedBankLoading: boolean;
  isAccountBalanceOrConnectedBankFetching: boolean;
}) {
  const accountBalance: number = isAccountBalanceOrConnectedBankError
    ? 0
    : accountBalanceData.isSuccess
    ? Number(accountBalanceData.data.balance) < 0
      ? 0
      : accountBalanceData.data.balance
    : 0;
  return (
    // <div>
    <StyledReadyTowItDrawBox>
      <Spin
        spinning={
          isAccountBalanceOrConnectedBankLoading ||
          isAccountBalanceOrConnectedBankFetching
        }
        style={{width: "100%"}}
      >
        <div className="text-content">
          <p className="heading-text">Ready to withdraw</p>
          {isAccountBalanceOrConnectedBankError ? (
            <p className="value-text">0</p>
          ) : accountBalanceData.isSuccess && connectedBankData.isSuccess ? (
            <p className="value-text">
              {connectedBankData.data.bank.currency} {accountBalance.toLocaleString()}
            </p>
          ) : null}
        </div>
      </Spin>
    </StyledReadyTowItDrawBox>
    // </div>
  );
}
